function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3333 21.3333H16V15.9999H14.6667M16 10.6666H16.0133M28 15.9999C28 17.5758 27.6896 19.1362 27.0866 20.5921C26.4835 22.048 25.5996 23.3709 24.4853 24.4852C23.371 25.5995 22.0481 26.4834 20.5922 27.0865C19.1363 27.6896 17.5759 27.9999 16 27.9999C14.4241 27.9999 12.8637 27.6896 11.4078 27.0865C9.95189 26.4834 8.62902 25.5995 7.51472 24.4852C6.40042 23.3709 5.5165 22.048 4.91345 20.5921C4.31039 19.1362 4 17.5758 4 15.9999C4 12.8173 5.26428 9.76509 7.51472 7.51466C9.76516 5.26422 12.8174 3.99994 16 3.99994C19.1826 3.99994 22.2348 5.26422 24.4853 7.51466C26.7357 9.76509 28 12.8173 28 15.9999Z",
  stroke: "#5048E5",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInfoIconPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconPurple);
export default __webpack_public_path__ + "static/media/info-icon-purple.31600626.svg";
export { ForwardRef as ReactComponent };